import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  max-width: 90vw;
  height: auto;
  max-height: 80vh;
  padding: 15px 15px 0;
  overflow: auto;

  ${Media.md`
    height: 100%;
    max-height: 100%;
    padding: 5px 5px 0;
  `}

  &::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.thumb};
    border-radius: 9px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.track};
  }
`;
